// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_3j_EAag3lKpmPAeHKA-Hlf","btnWrapper":"_1oRK5m32ydERO8PdvOK9M5","label":"_2cgKDELm6K4lifj9N4Fu-","btn":"_3lqCFOibQ7SSKj5V5uuZGJ","activeBtn":"Tghr8lVPehXZzY6FtyZ4Q"};